module.exports = __webpack_public_path__ + "static/belt-and-hat-7cc3454941ef731891848af064a6da53.png";